document.addEventListener('DOMContentLoaded', () => {
  const megaMenuDropdowns = document.querySelectorAll('.header .mega-menu')

  const searchToggle = document.querySelector('.search-toggle');
  const searchContainer = document.querySelector('.ed-header-search');
  const searchInput = document.querySelector('.ed-search .search__input');

  function searchResize() {
    if (window.innerWidth < 990 && searchContainer.classList.contains('searching')) {
      searchContainer.classList.remove('searching');
    }
  }

  function handleSearchContainer() {
    searchToggle.addEventListener('click', () => {
      if (document.querySelector('.ed-section-search')) {
        searchInput.focus();
        const length = searchInput.value.length;
        searchInput.setSelectionRange(length, length);
      } else {
        searchContainer.classList.toggle('searching');
      }
    });
  }

  megaMenuDropdowns.forEach((dropdown) => {
    dropdown.addEventListener('click', () => {
      if (searchContainer.classList.contains('searching')) {
        searchContainer.classList.remove('searching')
      }

      searchToggle.addEventListener('click', () => {
        dropdown.removeAttribute('open')
        dropdown.querySelector('summary').setAttribute('aria-expanded', false)
      })
    })
  });

  window.addEventListener('resize', searchResize);
  handleSearchContainer();
});